module.exports = "/_next/static/images/PrecisionSplicingActivation-05e95094bafa507f53365408afc76815.webp";